/**
 * Monitoring Widget directive for Infrastructure
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 23.12.2015-15:55
 */

lmApp
  .controller('MonitoringController', ['$scope', function ($scope) {


  }]);
